class VideoControls {
  constructor() {
    this.videos = false
    this.pausedVideos = {}
    this.init()
  }

  setVideos() {
    this.videos = document.getElementsByTagName('iframe')
  }

  init() {
    var $this = this
    //play when video is visible
    this.setVideos(document.getElementsByTagName('iframe'))
    // $this.videos = console.log($this.videos)
    $this.fraction = 0.8
    $this.players = []
    var tag = document.createElement('script')
    tag.src = 'https://www.youtube.com/iframe_api'
    var firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

    // 3. This function creates an <iframe> (and YouTube player)
    //    after the API code downloads.
    window.onYouTubeIframeAPIReady = function () {
      document.querySelectorAll('.embed-responsive-item').forEach((e, i) => {
        let pl = new YT.Player(e.attributes['id'].value, {
          events: {
            onReady: function (event) {
              $this.onPlayerReady(event, $this)
            },
            onStateChange: function (event) {
              $this.onPlayerStateChange(event, $this, i)
            },
          },
        })

        $this.players.push(pl)
      })
      // console.log('onYouTubeIframeAPIReady')
    }
  }

  checkInView(elem, partial) {
    let container = document.querySelector('.gallery-modal')
    var contHeight = container.scrollHeight
    var contTop = container.scrollTop
    var contBottom = contTop + contHeight

    if (!elem.offsetParent || !container) return false;

    var elemTop = elem.offsetParent.offsetTop - container.offsetTop
    var elemBottom = elemTop + elem.height

    return (
      container.scrollTop + window.innerHeight / 2 >
        elem.offsetParent.offsetTop &&
      container.scrollTop - 100 <
        elem.offsetParent.offsetTop + elem.offsetHeight
    )
  }

  checkScroll($this) {
    var $this = this
    for (var i = 0; i < $this.videos.length; i++) {
      var video = $this.videos[i]
      let isVideoVisible = $this.checkInView(video, true)

      if (isVideoVisible) {
        if ($this.players[i].getPlayerState && $this.players[i].getPlayerState() !== 1 && !$this.pausedVideos[i]) {
          $this.players[i].mute()
          $this.players[i].playVideo()
        }
      } else if ($this.players[i].pauseVideo) {
        $this.players[i].pauseVideo()
        $this.pausedVideos[i] = false
      }
    }
  }

  onPlayerReady(event, $this) {
    document
      .querySelector('.gallery-modal')
      .addEventListener('scroll', $this.checkScroll.bind($this), false)
    window.addEventListener('resize', $this.checkScroll.bind($this), false)
    document
      .querySelector('.gallery-modal')
      .addEventListener('load', $this.checkScroll.bind($this), false)
  }

  onPlayerStateChange(event, $this, i) {
    // console.log('event', event)
    if (event.data == YT.PlayerState.PAUSED) {
      $this.pausedVideos[i] = true
    }
    if (event.data == YT.PlayerState.PLAYING) {
      $this.pausedVideos[i] = false
    }
  }

  stopVideo() {
    this.player.stopVideo()
  }

  playVideo() {
    this.player.mute()
    this.player.playVideo()
  }

  pauseVideo() {
    this.player.pauseVideo()
  }
}
export default VideoControls
